import React from 'react';

import {serviceCRUD} from "../../../http/CRUD";
import CRUDTableQuery from "../CRUDTableQuery";
import useReload from "../../../hooks/useReload";
import CRUDTableStandart from "../CRUDTableStandart";

export default function ServiceListCRUDTable({type = 'standart', ...props}) {
    const {reload, reloadValue} = useReload();
    const columns = [
        {title: "ID", dataIndex: 'id', key: 'id'},
        {
            title: "Группа", key: 'group', render: (unknown, row) => row.group ? row.group.name :
                <span style={{color: "gray"}}>Не задан</span>
        } ,
        {
            title: "Подгруппа", key: 'subGroup', render: (unknown, row) => row?.subGroup ? row.subGroup?.name :
                <span style={{color: "gray"}}>Не задан</span>
        } ,
        {
            title: "Метод", key: 'kind', render: (unknown, row) => row?.kind ? row.kind?.name :
                <span style={{color: "gray"}}>Не задан</span>
        } ,
        {
            title: "Код", key: 'code', render: (unknown, row) => row?.code ? row.code :
                <span style={{color: "gray"}}>Не задан</span>
        },
        {
            title: "Единица услуги", key: 'kind', render: (unknown, row) => row?.unit ? row.unit?.name :
                <span style={{color: "gray"}}>Не задан</span>
        },
        {title: "Цена", dataIndex: 'price', key: 'price'},
    ];

    const searchFields = [
        {
            title: "Название",
            key: "name",
            compareType: "like",
            operandPosition: 1,
            filterType: "normal"
        }, {
            title: "Код",
            key: "code",
            compareType: "like",
            operandPosition: 1,
            filterType: "normal"
        },
        {
            title: "Цена",
            key: "price",
            compareType: "like",
            operandPosition: 1,
            filterType: "normal"
        },
    ]

    const CRUDTables = {
        standart: CRUDTableStandart,
        query: CRUDTableQuery,
    }

    const CRUDTable = CRUDTables[type]

    return (
        <>
            <CRUDTable search={props.search || serviceCRUD.search}
                            columns={columns}
                            searchFields={searchFields}
                            reloadValue={reloadValue}
                            {...props}
            />
        </>
    );
}
